import { PROTOCOL_PADDING } from 'components/canvas/components/nodes/components/protocol-node';
import { defaultNodeDimensions } from 'components/canvas/components/nodes';
import { Dimension } from 'types';
import { SurfaceNodeUnion, SurfaceBackgroundNode } from 'graphql/types';

interface NodeDimensionsOperations {
  getNodeDimensionsByType: (type: string) => Dimension;
  getNodeDimensions: (node: SurfaceNodeUnion) => Dimension;
}

export default function useNodeDimensionsOperations(): NodeDimensionsOperations {
  return { getNodeDimensionsByType, getNodeDimensions };
}

export function getNodeDimensionsByType(type: string): Dimension {
  return (
    defaultNodeDimensions[type?.toLowerCase()] ?? defaultNodeDimensions.general
  );
}

export function getNodeDimensions(node) {
  if (node?.contains) {
    const dimensions = getNodeDimensionsByType(node?.contains?.type);

    return {
      width: dimensions.width + PROTOCOL_PADDING * 2,
      height: dimensions.height + PROTOCOL_PADDING * 2,
    };
  }
  if (node.type === 'BACKGROUND') {
    // console.log('XXXX DIMENS', node);
    const n = node as SurfaceBackgroundNode;
    return node.size;
  }

  return getNodeDimensionsByType(node.type);
}
